module.exports = {"411002001":"西大街道","411002002":"东大街道","411002003":"西关街道","411002004":"南关街道","411002005":"北大街道","411002006":"五一路街道","411002007":"高桥营街道","411002008":"丁庄街道","411002009":"颍昌街道","411002010":"文峰街道","411002011":"新兴街道","411002013":"灞陵街道","411002015":"魏北街道","411002016":"产业集聚区街道","411002570":"东城区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411002.json
// module id = 1738
// module chunks = 0